// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"c1ba35c4","195":"7dbc681d","275":"a9bb39cf","318":"07af90da","341":"2ce67352","519":"aa421cc1","604":"46c0d988","651":"19769ca7","805":"6a4d4e94","825":"57208a16","916":"ca91fc4a","954":"80b9b336","978":"fcd0a983","992":"5f5763bc"}[chunkId] + ".chunk.js";
};